// extracted by mini-css-extract-plugin
export var bfcmFeatureCard = "bfcmFeatureCard-module--bfcmFeatureCard--a06c1";
export var charcoal = "bfcmFeatureCard-module--charcoal--a953d";
export var contentCard = "bfcmFeatureCard-module--contentCard--540e3";
export var eyebrow = "bfcmFeatureCard-module--eyebrow--c011c";
export var header = "bfcmFeatureCard-module--header--0dd9c";
export var headline = "bfcmFeatureCard-module--headline--a3102";
export var lightSand = "bfcmFeatureCard-module--lightSand--a711c";
export var subheadline = "bfcmFeatureCard-module--subheadline--cfbc0";